import {useEffect, useState} from 'react';
import image404 from '../../../assets/image/sponsor/404.svg';
import pending from '../../../assets/image/sponsor/pending.svg';
import useGetSponserList from '../../../services/hookService/sponsor/useGetSponserList/useGetSponserList';
import DotsLoading from '../../../components/dotsLoading';
import ActivePlanCard from '../ActivePlanCard';
import {useNavigate} from 'react-router-dom';
import SponsorHeader from '../components/header';
import SponsorHeaderText from '../components/SponsorHeaderText';
import SponsorCustomButton from '../components/CustomButton';
import MainFooter from '../../../components/mazraeKit/footers/footerMain';

const ActivePlanPage = () => {
  const navigate = useNavigate();
  const {data, isLoading} = useGetSponserList();
  const [activePlan, setActivePlan] = useState<sponserItem[]>([]);
  const [PendingPlan, setPendingPlan] = useState<sponserItem[]>([]);

  useEffect(() => {
    if (!data) return;
    const ActivePlans = data.filter(
      plan =>
        plan.status === 'accepted' && !plan.number_messages.previous_plans,
    );
    setActivePlan(ActivePlans);
    const pendPlan = data.filter(plan => plan.status === 'check');
    setPendingPlan(pendPlan);
  }, [data]);

  return (
    <div className="flex flex-col h-[100dvh] bg-white w-full text-gray-800 text-sm">
      <SponsorHeader title="حامی مالی" />
      <div className="h-[calc(100dvh-57px)] flex flex-col gap-6 justify-between px-8 pt-6 pb-8 overflow-hidden">
        <div className="flex flex-col gap-6 w-full overflow-hidden">
          {/* start text */}
          <SponsorHeaderText />
          {/* end text */}
          {/* start details plan */}
          {isLoading ? (
            <div className=" w-full flex flex-col items-center justify-center mt-16">
              <DotsLoading />
            </div>
          ) : activePlan.length ? (
            <div className="w-full flex-1 overflow-y-auto flex flex-col gap-6 pt-4 no-scrollbar">
              {activePlan.map(plan => (
                <ActivePlanCard key={plan.text} {...plan} />
              ))}
            </div>
          ) : PendingPlan.length ? (
            <div className=" w-full flex flex-col items-center gap-6 mt-16">
              <img src={pending} className="w-[40px] h-[60px]" />
              <span>درخواست شما در انتظار تأیید است</span>
            </div>
          ) : (
            <div className=" w-full flex flex-col items-center gap-6 mt-16">
              <img src={image404} className="w-[50px] h-[50px]" />
              <span>شما طرح فعالی ندارید</span>
            </div>
          )}

          {/* end details plan */}
        </div>
        {PendingPlan.length && data?.length ? (
          <div className="flex flex-col gap-4">
            <span>طرح در انتظار تایید</span>
            <span>{PendingPlan.length} طرح در انتظار تأیید دارید</span>
          </div>
        ) : null}
        {/* start link new plan */}
        <SponsorCustomButton
          outline={false}
          disabled={PendingPlan.length > 0}
          buttonType="button"
          title="فعالسازی طرح جدید"
          handler={() => {
            localStorage.setItem('sponsorForm', '');
            navigate('/sponsor/new-plan');
          }}
        />
        {/* end link new plan */}
      </div>

      <MainFooter />
    </div>
  );
};

export default ActivePlanPage;
